import { getAuthToken } from '../../lib/api/authenticated-fetch';
import type { MeridianSkillsListResponse } from './types';

export interface FetchMeridianSkillsParams {
  apiBaseUrl?: string;
  query?: string;
  category?: string;
  activatableOnly?: boolean;
  limit?: number;
  signal?: AbortSignal;
}

/**
 * Fetch marketplace skills for the composer picker / inventory modal.
 * Always hits Hub `/api/meridian/skills` (not entity-chat).
 */
export async function fetchMeridianSkills(
  params: FetchMeridianSkillsParams = {}
): Promise<MeridianSkillsListResponse> {
  const base = (params.apiBaseUrl ?? '/api/meridian').replace(/\/$/, '');
  const skillsBase = base.includes('entity-chat') ? '/api/meridian' : base;

  const search = new URLSearchParams();
  if (params.query?.trim()) search.set('q', params.query.trim());
  if (params.category?.trim()) search.set('category', params.category.trim());
  if (params.activatableOnly) search.set('activatableOnly', 'true');
  if (params.limit) search.set('limit', String(params.limit));

  const qs = search.toString();
  const url = `${skillsBase}/skills${qs ? `?${qs}` : ''}`;
  const token = getAuthToken();

  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    signal: params.signal,
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(
      typeof body.error === 'string' ? body.error : 'Failed to load skills'
    );
  }

  return (await response.json()) as MeridianSkillsListResponse;
}
